module.exports = __webpack_public_path__ + "static/leaforganicmuslin-dfee095f8310004d0de3202da52702e7.jpeg";